import PaddleCheckoutFrame from './PaddleCheckoutFrame'

export default PaddleCheckoutFrame
